// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"Navigation_navWrapper__1VN_X","settingsNav":"Navigation_settingsNav__1nn5y","calendarIcon":"Navigation_calendarIcon__2Leci"};